import React from 'react'

type ActionButtonProps = {
  onClick: (e: React.MouseEvent) => void
  className: string
  icon: React.ReactElement
  ariaLabel: string
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  className,
  icon,
  ariaLabel
}) => (
  <button onClick={onClick} className={className} aria-label={ariaLabel}>
    {icon}
  </button>
)
